export default __webpack_public_path__ + "static/303-79a1494754c37f30c44cf26f19c099bc.gif";